export default __webpack_public_path__ + "static/media/deleteObject.73bd03c7.png";